import Vue from 'vue';
import Router from 'vue-router';
import app from '@/config';

// Layouts
import { PublicLayout, PortalLayout } from '@/layouts';

// Pages
import { LoginPage } from '@/pages/auth';
import { Dashboard, NoGroupsFound, TV } from '@/pages/dashboards';
import { UserEditor, UserLayout, UserList } from '@/pages/users';
import { GroupDashboardEditor, GroupEditor, GroupLayout, GroupList } from '@/pages/groups';
import { Account } from '@/pages/account';
import { NotFound } from '@/pages/errors';
import { PublicDocument, Licensing } from '@/pages/documents';

// Guards
import { AnonymousOnlyGuard, AuthenticatedOnlyGuard, GroupAdminOnlyGuard } from './guards';


Vue.use(Router);

export default new Router({
    mode: app.routing.mode,
    routes: [
        {
            path: '/login',
            component: PublicLayout,
            beforeEnter: AnonymousOnlyGuard,
            children: [{ name: 'login', path: '', component: LoginPage }]
        },
        {
            path: '/legal',
            component: PublicLayout,
            children: [
                {
                    name: 'terms-of-use',
                    path: 'terms-of-use',
                    component: PublicDocument,
                    props: { title: 'Terms of Use', src: { url: app.api.legal.termsOfUse } }
                },
                {
                    name: 'privacy-policy',
                    path: 'privacy-policy',
                    component: PublicDocument,
                    props: { title: 'Privacy Policy', src: { url: app.api.legal.privacyPolicy } }
                }
            ]
        },
        { path: '/legal/licensing', name: 'licensing', component: Licensing },
        { path: '/not-found', component: NotFound },

        // Authenticated Only
        {
            path: '/',
            component: PortalLayout,
            beforeEnter: AuthenticatedOnlyGuard,
            children: [
                { name: 'home', path: '', redirect: { name: 'dashboards' } },
                { name: 'dashboards', path: 'dashboards', component: Dashboard, props: true },
                { name: 'tv', path: 'dashboards/tv', component: TV, props: true },
                { name: 'no-groups-found', path: 'dashboards/no-groups-found', component: NoGroupsFound, props: true },
                { name: 'group-dashboards', path: 'dashboards/:locationGroupId', component: Dashboard, props: true },
                { name: 'account', path: 'account', component: Account },

                {
                    path: 'users',
                    component: UserLayout,
                    beforeEnter: GroupAdminOnlyGuard,
                    children: [
                        { name: 'user-list', path: '', component: UserList },
                        { name: 'manage-user', path: ':globalUserId', component: UserEditor, props: true }
                    ]
                },

                {
                    path: 'groups',
                    component: GroupLayout,
                    children: [
                        { name: 'group-list', path: '', component: GroupList, beforeEnter: GroupAdminOnlyGuard },
                        { name: 'manage-group', path: ':locationGroupId', redirect: { name: 'manage-group-users' } },
                        { name: 'manage-group-dashboards', path: ':locationGroupId/dashboards', component: GroupEditor, beforeEnter: GroupAdminOnlyGuard, props: true },
                        { name: 'manage-group-users', path: ':locationGroupId/users', component: GroupEditor, beforeEnter: GroupAdminOnlyGuard, props: true },
                        { name: 'manage-group-dashboard', path: ':locationGroupId/dashboards/:dashboardId', component: GroupDashboardEditor, beforeEnter: GroupAdminOnlyGuard, props: true },
                        { name: 'manage-group-user', path: ':locationGroupId/users/:globalUserId', component: UserEditor, beforeEnter: GroupAdminOnlyGuard, props: true }
                    ]
                },

                { path: 'error', name: '500', component: Error, props: true },
				{ path: '*', name: '404', component: NotFound }
			]
		}
	]
});
